export default __webpack_public_path__ + "static/media/ponentes__claudiavelazqueza.dc381418.jpg";